import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['loading'];

  connect() {
    this.boundHandleTurboClick = this.handleTurboClick.bind(this);
    this.boundHideLoading = this.hideLoading.bind(this);

    document.addEventListener('turbo:click', this.boundHandleTurboClick);
    document.addEventListener('turbo:load', this.boundHideLoading);
  }

  disconnect() {
    document.removeEventListener('turbo:click', this.boundHandleTurboClick);
    document.removeEventListener('turbo:load', this.boundHideLoading);
  }

  handleTurboClick(event) {
    const pageLink = event.target.closest('.page-link');
    if (pageLink && !pageLink.closest('.disabled') && !pageLink.closest('.active')) {
      this.showLoading();
    }
  }

  showLoading() {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.remove('d-none');
    }

    const content = document.getElementById('announcements-content');
    if (content) {
      content.classList.add('d-none');
    }

    const paginationContainer = document.getElementById('announcement-pagination');
    if (paginationContainer) {
      paginationContainer.classList.add('d-none');
    }
  }

  hideLoading() {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.add('d-none');
    }

    const content = document.getElementById('announcements-content');
    if (content) {
      content.classList.remove('d-none');
    }
    const pagination = document.getElementById('announcement-pagination');
    if (pagination) {
      pagination.classList.remove('d-none');
    }
  }
}
